import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as firebase from 'firebase';

// A modern alternative to CSS resets
import 'normalize.css';
// Global css setting
import './global.css';

import configureStore from './store';
import Routes from './routes';

const store = configureStore({});

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: "afa-achievement.firebaseapp.com",
	databaseURL: "https://afa-achievement.firebaseio.com",
	projectId: "afa-achievement",
	storageBucket: "afa-achievement.appspot.com",
	messagingSenderId: "858667752378",
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: "G-HP24D1EZFF"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

const db = firebase.firestore();
export const statisticsRef = db.collection("statistics");

ReactDOM.render(
	<Provider store={store}>
		<Routes />
	</Provider>,
	document.getElementById('root'),
);
